import React, { useMemo } from "react";
import { useSuspense } from "@rest-hooks/react";
import { useParams } from "react-router-dom";

import Layout from 'components/layouts';
import MerchCollectionsList from "components/MerchCollectionsList";

import MerchCollectionResource from "resources/organization/MerchCollectionResource";
import EventResource from "resources/organization/EventResource";

const MerchCollections = () => {
  const { organizationId, eventId } = useParams();

  // Collection is event-level (not session-scoped) — no session_id in params.
  const requestParams = useMemo(
    () => ({ organization_id: organizationId, event_id: eventId }),
    [organizationId, eventId]
  );

  const event = useSuspense(EventResource.detail(), { organization_id: organizationId, id: eventId });

  const pageInfo = useMemo(
    () => ({
      name: event?.title ? `${event.title} — Merch` : "Merch collection",
      description: "Collect purchased merch at the store",
    }),
    [event]
  );

  return (
    <Layout context="teacher" activeMenuItem="events" pageInfo={pageInfo}>
      <MerchCollectionsList Resource={MerchCollectionResource} resourceParams={requestParams} />
    </Layout>
  );
};

export default MerchCollections;
